import fromPairs from 'lodash/fromPairs'
import omit from 'lodash/omit'
import * as Form from '../../components/form'
import * as Constants from './constants'
import * as Types from './types'

const setReceiving = (state: Types.State, params: Types.FetchMembersQueryParams): Types.FetchMembersQueryParams => {
  switch (state.filterForm.fields.status) {
    case Constants.SUBSCRIBED:
      return {
        ...params,
        is_receiving: 1,
      }
    case Constants.UNSUBSCRIBED:
      return {
        ...params,
        is_receiving: 0,
      }
    default:
      return params
  }
}

const setPartnerCode = (state: Types.State, params: Types.FetchMembersQueryParams): Types.FetchMembersQueryParams => {
  switch (state.filterForm.fields.partner_code) {
    case Constants.ALL_PARTNER_CODES:
      return omit(params, 'partner_code')
    case Constants.NO_PARTNER_CODES:
      return {
        ...params,
        partner_code: '0',
      }
    default:
      return params
  }
}

const filterParamsFromState = (state: Types.State): Types.FetchMembersQueryParams => {
  return setPartnerCode(state, setReceiving(state, {...state.filterForm.fields}))
}

export const fetchParamsFromState = (state: Types.State): Types.FetchMembersParams => {
  return {
    ...filterParamsFromState(state),
    limit: Constants.PAGE_SIZE,
    skip: (state.pager.pageNumber - 1) * Constants.PAGE_SIZE,
    sort: state.view.sortBy.field,
    sort_direction: state.view.sortBy.direction,
    source: Constants.EXPORT_SOURCE,
    updated_since: state.filterForm.fields.modifiedSince,
  }
}

export const defaultSort = (field: Types.Field): Types.Direction => {
  return (field === Constants.MemberFields.Updated || field === Constants.MemberFields.Created)
    ? Constants.SORT_BY.Desc : Constants.SORT_BY.Asc
}

export const getMemberDetailSaveParams = (detail: Types.MemberDetail, form: Types.DetailFormState): any => {
  const attributesToSave = form.fields.attributes
    .filter((attribute: any) => attribute.is_dirty === true)
    .map((attribute: any) => ([attribute.name, attribute.value]))
  return {
    id: detail.id,
    ...omit(Form.modifiedFields(form), 'attributes'),
    ...fromPairs(attributesToSave),
  };
}

export const getMemberDetailFields = (detail: Types.MemberDetail): Types.MemberDetailFormFields => {
  return {
    attributes: detail.memberAttributes,
    email: detail.email,
    first_name: detail.first_name,
    last_name: detail.last_name,
    schedule_id: detail.schedule_id,
  }
}



// WEBPACK FOOTER //
// ./src/pages/members/utils.ts